import React from 'react';
import '../Services.css';
import Image1 from '../../Gemco-Website-Images/Services/terrazzo_floor.jpg';

const Service_six = () => {
  return (
    <div className='wp_sub_service'>
      <div className="container wp_sub_service_container">
          <div className="row wp_service_row">
            <div className="content-column">
              <div className="inner-column wp_service_inner_column">
                <div className='sec-title forseotitle wp_service_sec_title'>
                  <h1>Commercial Kitchen MEP</h1>
                  <p>Complete MEP scope for commercial kitchens in hotels, restaurants and food operations —
                    delivered as a single contract with full technical accountability. GEMCO coordinates all MEP
                    trades so the operator deals with one specialist, not four subcontractors.</p>
                    <ul>
                      <li className="service_list_item">Gas supply</li>
                      <li className="service_list_item">distribution and appliance connections</li>
                      <li className="service_list_item">High-load electrical installation for commercial kitchen equipment</li>
                      <li className="service_list_item">Kitchen ventilation and canopy extraction systems</li>
                      <li className="service_list_item">Grease trap and drainage installation</li>
                      <li className="service_list_item">Fire suppression system installation (Ansul or equivalent)</li>
                      <li className="service_list_item">Plumbing — hot and cold water to all equipment positions</li>
                      <li className="service_list_item"> Civil works: core cutting, wall chasing, slab penetrations</li>
                      <li className="service_list_item">Full commissioning, DM approvals and Civil Defence inspections.</li>
                    </ul>
                </div>
              </div>
            </div>
            <div className="image-column">
              <img src={Image1} width="500" height="400" alt="" />
            </div>
          </div>
      </div>
    </div>
  )
}

export default Service_six